import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { getPathWithoutParam } from "@/utils/util";
import { mapGetters } from "vuex";
import { PRIVILEGES } from "@/utils/const";
import network from "@/utils/network";
const axios = network.createAxiosInstance();
export default {
  name: "SideMenu",
  async mounted() {
    // this.openedMenus = Array.from(this.openMenuKeys);
    this.openedMenus = ["dashboard", "time", "resource", "projects", "reporting"];
    try {
      const absenceResponse = await axios.get(`/v2/absence/absence-request/my-employees`);
      this.pendingRequests = absenceResponse.data?.pagination || [];
      const overtimeResponse = await axios.get(`/v2/enterprise/time-management/overtime/my-employees`);
      this.overtimeRequests = overtimeResponse.data?.pagination;
    } catch (error) {
      console.error(error);
    }
  },
  data() {
    return {
      openedMenus: [],
      dropdownRoutes: {
        absence: ["/my-absence-requests"],
        requests: ["/approval/overtime", "/approval/overtime/handle-requests", "/approval/absence", "/approval/absence/handle-requests", "/approval/schedule", "/approval/permissions"],
        settings: ["/settings/tiers", "/settings/project-dimensions", "/settings/project-base-data", "/settings/clients", "/settings/sudo", "/settings/sites", "/settings/work-schedule/sites", "/settings/permissions", "/settings/broadcast/templates", "/settings/tenants", "/controlling/logins", "/settings/admin-config", "/settings/roles", "/settings/overtime-policies"],
        projects: ["/projects/list#all", "/projects/list#simple", "/projects/list#support", "/projects/list#outsource", "/projects/list#public", "/projects/project-create"],
        ralloc: ["ralloc/utilization", "ralloc/utilization#projects", "ralloc/utilization#employees"],
        controlling: ["/controlling/dashboard", "/controlling/synopsis", "/controlling/timesheet", "/controlling/query", "/controlling/project-aggregation", "/controlling/risk-management", "/controlling/unknown-í", "/controlling/errors", "/controlling/invoices", "/controlling/resource-management"],
        userAdmin: ["/census/management", "/census/attributes", "/settings/teams", "/settings/team", "/census/schedules", "/census/admin/work-schedule", "/census/seatings", "/controlling/seating", "/controlling/seating-availability"],
        absenceAdmin: ["/absence/admin/requests", "/absence/admin/create", "/absence/admin/special-days", "/absence/admin/quotas", "/absence/admin/quota", "/absence/types", "/absence/admin/reports"],
        forecast: ["/forecast/chance-category", "/forecast/scenario", "/forecast/segment", "/forecast/plan", "/forecast/fact", "/forecast/dashboard"],
        reporting: ["/reports/timesheet", "/reports/query"]
      },
      pendingRequests: null,
      overtimeRequests: null
    };
  },
  computed: {
    ...mapGetters({
      displayName: "session/displayName",
      occupation: "session/occupation",
      avatar: "session/avatar",
      env: "env/getField"
    }),
    tenantBadge() {
      return this.env("TENANT_BADGE");
    },
    environment() {
      return this.env("ENVIRONMENT_BADGE");
    },
    version() {
      return this.env("CLIENT_VERSION")?.replace(/.+/g, "v$&");
    },
    pendingRequestsCount() {
      return (this.pendingRequests?.totalPendingCount || 0) + (this.overtimeRequests?.totalPendingCount || 0);
    },
    hasRequestsAnyActiveItem() {
      return this.dropdownRoutes.requests.includes(getPathWithoutParam(this.$route));
    },
    hasProjectsAnyActiveItem() {
      return getPathWithoutParam(this.$route).includes("/projects");
    },
    hasRallocAnyActiveItem() {
      return getPathWithoutParam(this.$route).includes("/ralloc");
    },
    hasControllingAnyActiveItem() {
      return this.dropdownRoutes.controlling.includes(getPathWithoutParam(this.$route));
    },
    hasSettingsAnyActiveItem() {
      return this.dropdownRoutes.settings.includes(getPathWithoutParam(this.$route));
    },
    hasUserAdminAnyActiveItem() {
      return this.dropdownRoutes.userAdmin.includes(getPathWithoutParam(this.$route));
    },
    hasAbsenceAdminAnyActiveItem() {
      return this.dropdownRoutes.absenceAdmin.includes(getPathWithoutParam(this.$route));
    },
    hasForecastAnyActiveItem() {
      return this.dropdownRoutes.forecast.includes(getPathWithoutParam(this.$route));
    },
    hasReportingAnyActiveItem() {
      return this.dropdownRoutes.reporting.includes(getPathWithoutParam(this.$route));
    },
    canSeeWorkSchedule: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.CENSUS.WORKSCHEDULE.GET, PRIVILEGES.CENSUS.WORKSCHEDULE.ADMIN);
    },
    canSeeAbsenceRequests: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.REQUEST.CREATE, PRIVILEGES.ABSENCE.REQUEST.ADMIN);
    },
    canSeeColleagues: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.CENSUS.MISC.LIST_COLLEAGUES, PRIVILEGES.CENSUS.MISC.ADMIN);
    },
    canSeeRequests: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.REQUEST.LIST_ASSIGNED, PRIVILEGES.ABSENCE.REQUEST.LIST_ANY, PRIVILEGES.ABSENCE.REQUEST.ADMIN, PRIVILEGES.ENTERPRISE.OVERTIME.LIST_REQUEST, PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN);
    },
    canSeeControlling: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.MISC.LIST_OVERVIEW, PRIVILEGES.ENTERPRISE.MISC.LIST_SYNOPSYS, PRIVILEGES.ENTERPRISE.MISC.ADMIN, PRIVILEGES.ENTERPRISE.PROJECT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.PROJECT.LIST_ANY, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN, PRIVILEGES.ENTERPRISE.PROJECT_EXTRAS.ADMIN, PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ASSIGNED, PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ANY, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.ADMIN);
    },
    canSeeResource: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.ADMIN, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.CREATE, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.LIST, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.EDIT, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.DELETE);
    },
    canSeeSettings: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.CENSUS.MISC.CREATE_SITE, PRIVILEGES.CENSUS.MISC.EDIT_SITE, PRIVILEGES.CENSUS.MISC.DELETE_SITE, PRIVILEGES.CENSUS.MISC.ADMIN, PRIVILEGES.ENTERPRISE.CLIENT.CREATE, PRIVILEGES.ENTERPRISE.CLIENT.EDIT, PRIVILEGES.ENTERPRISE.CLIENT.DELETE, PRIVILEGES.ENTERPRISE.CLIENT.ADMIN, PRIVILEGES.ENTERPRISE.TIER.CREATE, PRIVILEGES.ENTERPRISE.TIER.ADMIN, PRIVILEGES.ENTERPRISE.TIER.LIST_ANY, PRIVILEGES.ENTERPRISE.TIER.EDIT, PRIVILEGES.ENTERPRISE.TIER.DELETE, PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.CREATE, PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.EDIT, PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.DELETE, PRIVILEGES.ENTERPRISE.PROJECT_CATEGORIES.ADMIN, PRIVILEGES.BULWARK.ROLE.LIST, PRIVILEGES.BULWARK.ROLE.ADMIN, PRIVILEGES.TENANT.CONFIG.ADMIN);
    },
    canSeeUserAdmin: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.CENSUS.USER.CREATE, PRIVILEGES.CENSUS.USER.EDIT, PRIVILEGES.CENSUS.USER.DELETE, PRIVILEGES.CENSUS.USER.ADMIN, PRIVILEGES.ENTERPRISE.TIER.LIST_ANY, PRIVILEGES.ENTERPRISE.TIER.ADMIN, PRIVILEGES.CENSUS.TEAM.CREATE, PRIVILEGES.CENSUS.TEAM.EDIT, PRIVILEGES.CENSUS.TEAM.DELETE, PRIVILEGES.CENSUS.TEAM.ADMIN, PRIVILEGES.CENSUS.WORKSCHEDULE.LIST, PRIVILEGES.CENSUS.WORKSCHEDULE.EDIT, PRIVILEGES.CENSUS.WORKSCHEDULE.ADMIN);
    },
    canSeeAbsenceAdmin: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.REQUEST.CREATE_ANY, PRIVILEGES.ABSENCE.REQUEST.ADMIN, PRIVILEGES.ABSENCE.SPECIAL_DAY.CREATE, PRIVILEGES.ABSENCE.SPECIAL_DAY.EDIT, PRIVILEGES.ABSENCE.SPECIAL_DAY.DELETE, PRIVILEGES.ABSENCE.SPECIAL_DAY.ADMIN, PRIVILEGES.ABSENCE.QUOTA.LIST, PRIVILEGES.ABSENCE.QUOTA.ADMIN, PRIVILEGES.ABSENCE.TYPE.CREATE, PRIVILEGES.ABSENCE.TYPE.EDIT, PRIVILEGES.ABSENCE.TYPE.DELETE, PRIVILEGES.ABSENCE.TYPE.ADMIN, PRIVILEGES.ABSENCE.MISC.EXPORT_ABSENCES, PRIVILEGES.ABSENCE.MISC.ADMIN);
    },
    canSeeForecast: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.FORECAST.PLAN.LIST_OWN, PRIVILEGES.ENTERPRISE.FORECAST.PLAN.LIST_ANY, PRIVILEGES.ENTERPRISE.FORECAST.FACT.LIST_OWN, PRIVILEGES.ENTERPRISE.FORECAST.FACT.LIST_ANY, PRIVILEGES.ENTERPRISE.FORECAST.SEGMENT.LIST, PRIVILEGES.ENTERPRISE.FORECAST.MISC.DASHBOARD, PRIVILEGES.ENTERPRISE.FORECAST.MISC.ADMIN);
    },
    canSeeReporting: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY, PRIVILEGES.ENTERPRISE.TIMESHEET.ADMIN, PRIVILEGES.ENTERPRISE.REPORT.GET_MONEYLESS, PRIVILEGES.ENTERPRISE.REPORT.ADMIN);
    },
    canHandleOvertimeRequests: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.OVERTIME.LIST_REQUEST, PRIVILEGES.ENTERPRISE.OVERTIME.ADMIN);
    },
    canHandleAbsenceRequests: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.REQUEST.LIST_ASSIGNED, PRIVILEGES.ABSENCE.REQUEST.LIST_ANY, PRIVILEGES.ABSENCE.REQUEST.ADMIN);
    },
    canSeeMoneylessProjects() {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT.GET_PUBLIC, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN);
    },
    canSeeTimesheets: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY, PRIVILEGES.ENTERPRISE.TIMESHEET.ADMIN);
    },
    canSeeMoneylessReport: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.REPORT.GET_MONEYLESS, PRIVILEGES.ENTERPRISE.REPORT.ADMIN);
    },
    canSeeExecutive: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.MISC.LIST_OVERVIEW, PRIVILEGES.ENTERPRISE.MISC.ADMIN);
    },
    canSeeTeam: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.MISC.LIST_SYNOPSYS, PRIVILEGES.ENTERPRISE.MISC.ADMIN);
    },
    canSeeProjects: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.PROJECT.LIST_ANY, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN);
    },
    canSeeSheets: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ASSIGNED, PRIVILEGES.ENTERPRISE.TIMESHEET.GET_ANY, PRIVILEGES.ENTERPRISE.TIMESHEET.ADMIN);
    },
    canSeeQuery: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.PROJECT.LIST_ANY, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN);
    },
    canSeeProjectAggregation: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.LIST_ANY, PRIVILEGES.ENTERPRISE.PROJECT_AGGREGATION.ADMIN);
    },
    canSeeShame: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ASSIGNED, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.LIST_ANY, PRIVILEGES.ENTERPRISE.RISK_MANAGEMENT.ADMIN);
    },
    canSeeInvoices: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT_EXTRAS.ADMIN);
    },
    canSeeResourceAllocation: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.LIST, PRIVILEGES.RALLOC.RESOURCE_ALLOCATION.ADMIN);
    },
    canGetAbsenceReports: function () {
      return this.$store.getters["session/hasAnyAuthority"](PRIVILEGES.ABSENCE.MISC.EXPORT_ABSENCES, PRIVILEGES.ABSENCE.MISC.ADMIN);
    },
    canSeeFinancialDashboard: function () {
      // TODO
      return true;
    },
    canSeeResourceDashboard: function () {
      // TODO
      return true;
    },
    menuItems() {
      return [
      // region user
      {
        icon: "fa-regular fa-gauge-high",
        label: this.$tf("sidebar.dashboard|Dashboard"),
        classList: [],
        visible: this.canSeeResource,
        key: "dashboard",
        items: [
          // {
          //   link: "/dashboard/financial",
          //   icon: "",
          //   label: this.$tf(
          //     "sidebar.dashboard.financial|Pénzügyi vezérlőpult"
          //   ),
          //   visible: this.canSeeFinancialDashboard,
          //   key: "dashboard.financial",
          // },
          // {
          //   link: "/dashboard/resource",
          //   icon: "",
          //   label: this.$tf(
          //     "sidebar.dashboard.resource|Erőforrás vezérlőpult"
          //   ),
          //   visible: this.canSeeResourceDashboard,
          //   key: "dashboard.resource",
          // },
          // {
          //   link: "/dashboard/risk-management",
          //   icon: "",
          //   label: this.$tf(
          //     "sidebar.dashboard.riskManagement|Kockázatkezelés"
          //   ),
          //   visible: this.canSeeShame,
          //   key: "dashboard.riskManagement",
          // },
          // {
          //   link: "/dashboard/my",
          //   icon: "",
          //   label: this.$tf("sidebar.dashboard.my|Saját vezérlőpult"),
          //   visible: true,
          //   key: "dashboard.my",
          // },
        ]
      }, {
        icon: "fa-regular fa-calendar",
        label: this.$tf("sidebar.time|Időkezelés"),
        classList: [],
        visible: true,
        key: "time",
        items: [{
          link: "/",
          icon: "",
          label: this.$tf("sidebar.time.overview|Áttekintés"),
          visible: true,
          key: "time.overview"
        }, {
          link: "/time-management/logging",
          icon: "",
          label: this.$tf("sidebar.time.timeLogging|Időkövetés"),
          visible: true,
          key: "time.timeLogging"
        }, {
          link: "/my-absence-requests",
          icon: "",
          label: this.$tf("sidebar.time.timeOff|Szabadságaim"),
          visible: true,
          key: "time.timeOff"
        }, {
          link: "/pending-requests",
          icon: "",
          label: this.$tf("sidebar.time.requests|Kérelmek"),
          visible: this.canSeeRequests,
          key: "time.requests"
        }]
      }, {
        icon: "fa-regular fa-users",
        label: this.$tf("sidebar.resource|Erőforrások"),
        classList: [],
        visible: this.canSeeResource,
        key: "resource",
        items: [{
          link: "/ralloc/utilization",
          icon: "",
          label: this.$tf("sidebar.resource.resourcePlanner|Erőforrás-tervezés"),
          visible: true,
          key: "resource.resourcePlanner"
        }, {
          link: "/employee-explorer",
          icon: "",
          label: this.$tf("sidebar.resource.employeeExplorer|Felhasználó-böngésző"),
          visible: true,
          key: "resource.employeeExplorer"
        }]
      }, {
        link: "/tasks",
        icon: "fa-regular  fa-stopwatch",
        label: this.$tf("sidebar.tasks|Feladatok"),
        classList: [],
        visible: this.isUsingSelftracking,
        key: "tasks"
      },
      // endregion
      // region admin
      {
        icon: "fa-regular fa-briefcase",
        label: this.$tf("sidebar.projects.menu|Projektek"),
        classList: [],
        visible: this.canSeeControlling,
        key: "projects",
        items: [{
          link: "/projects/list#all",
          icon: "",
          label: this.$tf("sidebar.projects.all|Összevont"),
          visible: this.canSeeControlling,
          key: "projects.all"
        }, {
          link: "/projects/list#simple",
          icon: "",
          label: this.$tf("sidebar.projects.normal|Hagyományos"),
          visible: this.canSeeControlling,
          key: "projects.simple"
        }, {
          link: "/projects/list#support",
          icon: "",
          label: this.$tf("sidebar.projects.support|Folyamatos"),
          visible: this.canSeeControlling,
          key: "projects.support"
        }, {
          link: "/projects/list#outsource",
          icon: "",
          label: this.$tf("sidebar.projects.outsource|Outsource"),
          visible: this.canSeeControlling,
          key: "projects.outsource"
        }, {
          link: "/projects/list#public",
          icon: "",
          label: this.$tf("sidebar.projects.moneyless|Publikus"),
          visible: this.canSeeMoneylessProjects,
          key: "projects.public"
        }]
      }, {
        icon: "",
        label: this.$tf("sidebar.controlling.menu|Felügyelet"),
        classList: [],
        visible: this.canSeeControlling,
        key: "controlling",
        items: [{
          link: "/controlling/timesheet",
          icon: "",
          label: this.$tf("sidebar.controlling.timesheets|Timesheetek"),
          visible: this.canSeeSheets,
          key: "controlling.timesheets"
        }, {
          link: "/controlling/query",
          icon: "",
          label: this.$tf("sidebar.controlling.timesheet_query|Lekérdezés"),
          visible: this.canSeeQuery,
          key: "controlling.query"
        }, {
          link: "/reporting/my-reports",
          icon: "",
          // label: this.$tf("sidebar.riporting.aggregation|Riporting"),
          label: "Riporting",
          visible: this.canSeeProjectAggregation,
          key: "controlling.aggregation"
        }, {
          link: "/controlling/risk-management",
          icon: "",
          label: this.$tf("sidebar.controlling.risk_management|Kockázatmenedzsment"),
          visible: this.canSeeShame,
          key: "controlling.shame"
        }, {
          link: "/controlling/invoices",
          icon: "",
          label: this.$tf("sidebar.controlling.invoices|Számlák"),
          visible: this.canSeeInvoices,
          key: "projects.invoices"
        }]
      }, {
        icon: "fa-regular fa-book",
        label: this.$tf("sidebar.reporting.menu|Riportok"),
        classList: [],
        visible: this.canSeeReporting,
        key: "reporting",
        items: [{
          link: "/reporting/my-reports",
          icon: "",
          label: this.$tf("sidebar.reporting.my|My reports"),
          visible: this.canSeeProjectAggregation,
          key: "reporting.my"
        }, {
          link: "/reporting/reports",
          icon: "",
          label: this.$tf("sidebar.reporting.aggregation|Report library"),
          visible: this.canSeeProjectAggregation,
          key: "reporting.aggregation"
        }]
      }, {
        icon: "",
        link: "/forecast",
        label: this.$tf("sidebar.forecast.menu|Forecast"),
        classList: ["sidebar-icon-fa"],
        visible: false,
        key: "forecast",
        items: []
      }
      // endregion
      ];
    },
    logo() {
      return process.env.VUE_APP_MENU_LOGO_CLOSED;
      // return getCurrentTheme() === UI_THEMES.DARK
      //   ? process.env.VUE_APP_MENU_LOGO_DARK
      //   : process.env.VUE_APP_MENU_LOGO;
    },
    openMenuKeys() {
      // Use path instead of fullPath to ignore query parameters
      const currentPath = this.$route.path;
      const currentFullPath = this.$route.fullPath;
      const currentSidebarKey = this.$route.meta?.sidebarItemKey;
      const keys = new Set();
      const findActiveBranch = (items, parents = []) => {
        for (const item of items) {
          if (!item.link) {
            if (item.items?.length) {
              const childMatch = findActiveBranch(item.items, [...parents, item.key]);
              if (childMatch) return true;
            }
            continue;
          }

          // Extract path and hash from item.link if it contains a hash
          const linkParts = item.link.split("#");
          const linkPath = linkParts[0];
          const linkHash = linkParts[1] ? "#" + linkParts[1] : null;

          // Compare path without query parameters for exact and prefix matches
          let pathMatches = false;
          if (linkHash) {
            // For hash-based routes (e.g., /projects/list#all)
            // Check if path matches and hash matches (ignoring query params)
            const currentHash = currentFullPath.includes("#") ? "#" + currentFullPath.split("#")[1] : null;
            pathMatches = currentPath === linkPath && currentHash === linkHash;
          } else {
            // For regular routes without hash
            pathMatches = currentPath === item.link || currentPath.startsWith(item.link + "/");
          }
          const keyMatches = currentSidebarKey && item.key === currentSidebarKey;
          if (pathMatches || keyMatches) {
            parents.forEach(key => keys.add(key));
            if (item.key) keys.add(item.key);
            return true;
          }
          if (item.items?.length) {
            const childMatch = findActiveBranch(item.items, [...parents, item.key]);
            if (childMatch) return true;
          }
        }
        return false;
      };
      findActiveBranch(this.menuItems);
      return keys;
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch("session/logMeOut").then(() => {
        this.$router.push("/login");
      });
    },
    toggleMenu(menu) {
      if (this.openedMenus.includes(menu)) {
        this.openedMenus.splice(this.openedMenus.indexOf(menu), 1);
      } else {
        this.openedMenus.push(menu);
      }
    }
  }
};